import { BatchWorkspace } from 'components/Workspaces/Batch';

export default BatchWorkspace;
